import { ApiModule as o, LoggerModule as e } from "@packages/common";
import { FavoritesService as r } from "./main37.js";
import { UserModule as i } from "./main68.js";
import "./main69.js";
const s = {
  name: "FavoritesModule",
  modules: [o, e, i],
  providers: [r]
};
export {
  s as FavoritesModule
};
